/*
 * Trade Secrets wishlist - a browser-only list (Shopify has no native wishlist).
 *
 * - <ts-wishlist-button>  heart toggle on a product card (snippets/ts-wishlist-button.liquid)
 * - <ts-wishlist-count>   live count bubble on the header heart
 * - the drawer            right-hand panel, 420px, opened from the header heart
 *                         (components/feedback/Drawer.jsx, ui_kits/storefront/Overlays.jsx WishlistDrawer)
 *
 * Stored as [{id, handle}] under one localStorage key. Product details are fetched fresh from
 * /products/<handle>.js when the drawer opens, so price and availability are never stale.
 */
(function () {
  var KEY = 'ts:wishlist:v2';
  var HEART =
    '<svg class="ts-heart" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.29 1.5 4.04 3 5.5l7 7Z"/></svg>';
  var HEART_OUTLINE = HEART.replace('fill="currentColor"', 'fill="none"');
  var CLOSE =
    '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('ts:wishlist:change', { detail: { count: list.length } }));
  }

  function has(id) {
    return read().some(function (x) {
      return String(x.id) === String(id);
    });
  }

  function toggle(id, handle) {
    var list = read();
    var i = list.findIndex(function (x) {
      return String(x.id) === String(id);
    });
    if (i === -1) list.push({ id: String(id), handle: handle });
    else list.splice(i, 1);
    write(list);
    return i === -1;
  }

  function strings() {
    var el = document.getElementById('ts-wishlist-strings');
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {
        title: 'Wishlist',
        close: 'Close',
        remove: 'Remove from wishlist',
        emptyTitle: 'Your wishlist is empty',
        emptyText: '',
        explore: 'Explore',
        exploreUrl: '/collections/all',
        locale: 'en',
      };
    }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD';
    try {
      // The shop writes Canadian dollars as C$12.34 (Intl says CA$ in an English locale).
      var text = new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency,
      }).format(cents / 100);
      return currency === 'CAD' ? text.replace(/^CA\$/, 'C$') : text;
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* ---- product card heart ---- */
  class TsWishlistButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.button.addEventListener('click', this.onClick.bind(this));
      this._sync = this.sync.bind(this);
      document.addEventListener('ts:wishlist:change', this._sync);
      this.sync();
    }
    disconnectedCallback() {
      document.removeEventListener('ts:wishlist:change', this._sync);
    }
    onClick(e) {
      /* the card around it is a link */
      e.preventDefault();
      e.stopPropagation();
      var on = toggle(this.dataset.productId, this.dataset.productHandle);
      this.paint(on);
      if (on && this.button.animate) {
        this.button.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.15)' }, { transform: 'scale(1)' }], {
          duration: 180,
          easing: 'ease-out',
        });
      }
    }
    sync() {
      this.paint(has(this.dataset.productId));
    }
    paint(on) {
      this.classList.toggle('is-active', on);
      this.button.setAttribute('aria-pressed', String(on));
      this.button.setAttribute('aria-label', on ? this.dataset.labelRemove : this.dataset.labelAdd);
      var text = this.querySelector('.ts-wishlist-pdp__text');
      if (text) text.textContent = on ? text.dataset.textSaved : text.dataset.textAdd;
    }
  }

  /* ---- header count bubble ---- */
  class TsWishlistCount extends HTMLElement {
    connectedCallback() {
      this._sync = this.sync.bind(this);
      document.addEventListener('ts:wishlist:change', this._sync);
      this.sync();
    }
    disconnectedCallback() {
      document.removeEventListener('ts:wishlist:change', this._sync);
    }
    sync() {
      var n = read().length;
      this.textContent = n > 99 ? '99+' : String(n);
      this.hidden = n === 0;
    }
  }

  if (!customElements.get('ts-wishlist-button')) customElements.define('ts-wishlist-button', TsWishlistButton);
  if (!customElements.get('ts-wishlist-count')) customElements.define('ts-wishlist-count', TsWishlistCount);

  /* ---- drawer ---- */
  var drawer = null;
  var opener = null;

  function build() {
    var t = strings();
    var root = document.createElement('div');
    root.className = 'ts-drawer';
    root.setAttribute('aria-hidden', 'true');
    root.innerHTML =
      '<div class="ts-drawer__scrim" data-ts-close></div>' +
      '<aside class="ts-drawer__panel" role="dialog" aria-modal="true" aria-label="' + esc(t.title) + '">' +
      '<header class="ts-drawer__head"><p class="ts-label">' + esc(t.title) + '</p>' +
      '<button type="button" class="ts-drawer__close" data-ts-close aria-label="' + esc(t.close) + '">' + CLOSE + '</button></header>' +
      '<div class="ts-drawer__body"></div></aside>';
    document.body.appendChild(root);
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-ts-close]')) close();
      var rm = e.target.closest('[data-ts-remove]');
      if (rm) {
        e.preventDefault();
        toggle(rm.dataset.tsRemove, rm.dataset.handle);
        render();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) close();
    });
    return root;
  }

  function card(p, t) {
    var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') : '';
    var sale = p.compare_at_price && p.compare_at_price > p.price;
    return (
      '<article class="ts-wl-card">' +
      '<a class="ts-wl-card__media" href="' + esc(p.url) + '">' +
      (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
      '</a>' +
      '<button type="button" class="ts-wl-card__remove ts-wishlist-card__button" data-ts-remove="' + esc(p.id) +
      '" data-handle="' + esc(p.handle) + '" aria-label="' + esc(t.remove) + '" aria-pressed="true">' + HEART + '</button>' +
      '<div class="ts-wl-card__info">' +
      (p.vendor ? '<p class="ts-label ts-wl-card__brand">' + esc(p.vendor) + '</p>' : '') +
      '<a class="ts-wl-card__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<p class="ts-wl-card__price' + (sale ? ' is-sale' : '') + '">' + money(p.price) +
      (sale ? ' <s>' + money(p.compare_at_price) + '</s>' : '') + '</p>' +
      '</div></article>'
    );
  }

  function render() {
    var t = strings();
    var body = drawer.querySelector('.ts-drawer__body');
    var list = read();
    if (!list.length) {
      body.innerHTML =
        '<div class="ts-empty">' + HEART_OUTLINE.replace('class="ts-heart"', 'class="ts-empty__icon"') +
        '<h3 class="ts-empty__title">' + esc(t.emptyTitle) + '</h3>' +
        '<p class="ts-empty__text">' + esc(t.emptyText) + '</p>' +
        '<a class="button ts-empty__action" href="' + esc(t.exploreUrl) + '">' + esc(t.explore) + '</a></div>';
      return;
    }
    body.innerHTML = '<div class="ts-wl-grid" aria-busy="true"></div>';
    Promise.all(
      list.map(function (x) {
        return fetch('/products/' + encodeURIComponent(x.handle) + '.js')
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      /* drop products that no longer exist, keep the list tidy */
      var alive = products.filter(Boolean);
      if (alive.length !== list.length) {
        write(
          list.filter(function (x) {
            return alive.some(function (p) {
              return String(p.id) === String(x.id);
            });
          })
        );
      }
      if (!alive.length) return render();
      body.innerHTML = '<div class="ts-wl-grid">' + alive.map(function (p) { return card(p, t); }).join('') + '</div>';
    });
  }

  function open(from) {
    if (!drawer) drawer = build();
    opener = from || document.activeElement;
    render();
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ts-no-scroll');
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      var c = drawer.querySelector('.ts-drawer__close');
      if (c) c.focus();
    });
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ts-no-scroll');
    if (opener && opener.focus) opener.focus();
  }

  document.addEventListener('click', function (e) {
    /* a menu item whose URL ends in #wishlist (e.g. footer > Your Account > Wishlist) opens the drawer */
    var trigger = e.target.closest('[data-ts-wishlist-open], a[href$="#wishlist"]');
    if (trigger) {
      e.preventDefault();
      open(trigger);
    }
  });

  /* other places (the footer "Wishlist" link) can ask for the drawer with a custom event */
  document.addEventListener('ts:wishlist:open', function () {
    open();
  });
})();
